// Scroll To Top Button

if (document.querySelectorAll("#nav-height").length) {
let mybutton = document.getElementById("back-to-top");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

document.getElementById("back-to-top").onclick = function() {topFunction()};

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
}
// Metanav - Slide Up On Scroll

// if (document.querySelectorAll("#metanav").length) {
//   let scrollpos = window.scrollY

//   const header = document.getElementById("metanav")
//   const scrollChange = 1
  
//   const add_class_on_scroll = () => header.classList.add("display-none")
//   const remove_class_on_scroll = () => header.classList.remove("display-none")
  
//   window.addEventListener('scroll', function() { 
//     scrollpos = window.scrollY;
  
//     if (scrollpos >= scrollChange) { add_class_on_scroll() }
//     else { remove_class_on_scroll() }
    
//   })
// }

// Navbar  - Change height on Scroll

if (document.querySelectorAll("#nav-height").length) {
  let scrollpos = window.scrollY

  const header = document.getElementById("nav-height")
  const scrollChange = 1
  
  const add_class_on_scroll = () => header.classList.add("height-small")
  const remove_class_on_scroll = () => header.classList.remove("height-small")
  
  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;
  
    if (scrollpos >= scrollChange) { add_class_on_scroll() }
    else { remove_class_on_scroll() }
    
  })
}




// Dropdown opens on mousehover

document.addEventListener("DOMContentLoaded", function(){

  if (window.innerWidth > 992) {
  
    document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){
  
      everyitem.addEventListener('mouseover', function(e){
  
        let el_link = this.querySelector('a[data-bs-toggle]');
  
        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add('show');
          nextEl.classList.add('show');
        }
      });
      everyitem.addEventListener('mouseleave', function(e){
        let el_link = this.querySelector('a[data-bs-toggle]');
  
        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove('show');
          nextEl.classList.remove('show');
        }  
      })
    });
  }
}); 
document.addEventListener("DOMContentLoaded", function(){

  if (window.innerWidth > 992) {
  
    document.querySelectorAll('.dropdown-item.dropdown-toggle.has-submenu').forEach(function(everyitem){
  
      everyitem.addEventListener('mouseover', function(e){
  
        let el_link = this.querySelector('a[data-bs-toggle]');
  
        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add('show');
          nextEl.classList.add('show');
        }
      });
      everyitem.addEventListener('mouseleave', function(e){
        let el_link = this.querySelector('a[data-bs-toggle]');
  
        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove('show');
          nextEl.classList.remove('show');
        }  
      })
    });
  }
}); 

// Navigation Multiple Dropdowns
document.addEventListener("DOMContentLoaded", function(){
  /////// Prevent closing from click inside dropdown
  document.querySelectorAll('.dropdown-menu').forEach(function(element){
    element.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  })
}); 

// Flickity Carousel


// FLickity
import Flickity from 'flickity';
import {createLightbox} from "./modules/lightbox";

const infinitySlider = document.querySelectorAll('.main-carousel');

infinitySlider.forEach(carouselImage => {
  const carousel = new Flickity( carouselImage, {
    // options
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    wrapAround: true
  });

  carousel.on('staticClick', function(event, pointer, cellElement, cellIndex) {
    if (!cellElement || !cellElement.classList.contains('with-lightbox'))
      return;

    createLightbox(cellElement.dataset.image);
  });
});


// Formular Objektdaten einfügen
document.querySelectorAll('input[value^="auto-"]').forEach(el => {
  const target = document.getElementById(el.value.replace('auto-', ''))
  el.value = target ? target.innerText : '';
})
